var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{staticClass:"component__icon",domProps:{"innerHTML":_vm._s(_vm.icons[_vm.icon].toSvg({
    height: _vm.getHeight,
    width: _vm.getWidth,
    color: _vm.getColor
  }))}})
}
var staticRenderFns = []

export { render, staticRenderFns }